// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"665f00f9","281":"e0727367","316":"357022bc","489":"4c7f7b5a","525":"63a9140e","539":"2344e443"}[chunkId] + ".chunk.js";
};